import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

/*
This entrypoint is using JSResourceForInteraction instead of the preferred JSResourceForUserVisible.
This is because the phone configuration page utilises a binary download button, using a binary that is hosted within AFM.
This binary load mechanism is not compatible with SSR, so the package needs to be excluded from the SSR bundle.
*/
export const helpCenterSettingsPhoneConfigurationAppEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "async-help-center-settings-phone-configuration-app" */ './src/ui'
			),
	),
	getPreloadProps: () => ({}),
});
